import React, {Component} from 'react';
import './App.css';
import CMSRoutes from '../routes';
import PageTop from '../containers/layout/page_top';
import {ConnectedRouter} from 'react-router-redux';
import {withStyles} from 'material-ui/styles';
import styles from './App.style';
import {connect} from 'react-redux';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import {CMSToaster} from './toaster/toaster';
import Paper from 'material-ui/Paper';
import {LinearProgress} from 'material-ui/Progress';
import {signOut} from '../containers/auth/actions';

class App extends Component {
    componentWillMount() {
        if (typeof this.props.user === 'undefined') {
            this.props.signOut();
        }
    }

    render() {
        const classes = this.props.classes;

        let isPage =
            this.props.location !== null &&
            this.props.location.pathname.startsWith('/page');

        if (this.props.uploadProgress !== null && !isPage) {
            window.onscroll = () => {
                let progressBar = document.getElementById(
                    'paperImageUploading'
                );

                if (progressBar !== null && window.pageYOffset > 50) {
                    progressBar.classList.add('onScrollUploadProgressTop0');
                } else if (progressBar !== null && window.pageYOffset < 50) {
                    progressBar.classList.remove('onScrollUploadProgressTop0');
                }
            };
        }

        return (
            <ConnectedRouter history={this.props.history}>
                <div>
                    <div className={classes.root}>
                        <div className={classes.appFrame}>
                            {typeof this.props.user !== 'undefined' && (
                                <PageTop />
                            )}
                            <main className={classes.content}>
                                <CMSToaster />
                                <CMSRoutes />
                                {this.props.uploadProgress !== null && !isPage && (
                                    <Paper
                                        elevation={2}
                                        className={classes.paperImageUploading}
                                        id='paperImageUploading'
                                    >
                                        <LinearProgress
                                            variant='buffer'
                                            color='secondary'
                                            value={this.props.uploadProgress}
                                            valueBuffer={100}
                                            style={{height: '100%'}}
                                        />
                                        <div
                                            className={
                                                classes.textImageUploading
                                            }
                                        >
                                            Uploading, please wait...
                                            {'Upload progress: ' +
                                                this.props.uploadProgress +
                                                '%'}
                                        </div>
                                    </Paper>
                                )}
                            </main>
                        </div>
                    </div>
                </div>
            </ConnectedRouter>
        );
    }
}

const mapStateToProps = state => ({
    sidebarOpen: state.layout.sidebarOpen,
    uploadProgress: state.layout.progressPercent,
    location: state.router.location,
    user: state.auth.user
});

export default connect(
    mapStateToProps,
    {signOut}
)(withStyles(styles)(App));



// WEBPACK FOOTER //
// ./src/components/App.js